enum HtmlEntities {
  RIGHT_ARROW = '&rarr;',
  DOWN_ARROW = '&darr;',
  LEFT_ARROW = '&larr;',
}

export default HtmlEntities;
